import React, { useState } from "react";
import { useUserContext } from "../../../../context/UserContext.jsx";
import { createPortal } from "react-dom";
import { apiRequest } from "@/network/apiClient"
import { API_ENDPOINTS } from "@/api/apiEndpoints";
import { toast } from "react-toastify"

const InteractionButtons = ({leadId}) => {
  const { userId } = useUserContext();
  const [selectedInteraction, setSelectedInteraction] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // 🔹 Today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    notes: "",
    purpose: "",
    date: "",
    type: "",
    leadId: leadId || "", // Ensure it's not null initially
  });

  const purposeOptions = [
    "Promotions/FX Rate",
    "Follow up for document (Order)",
    "Other",
    "Follow up for Next Order (Retention)",
    "Cold Message (Insurance, Financing etc)",
  ];

  const interactionTypes = [
    {
      type: "Call",
      icon: (
        <img src="/icons/call.svg" className='size-7'/>
      ),
    },
    {
      type: "Text/Message",
      icon: (
        <img src="/icons/whatsapp.svg" className='size-7'/>
      ),
    },
    {
      type: "E-mail",
      icon: (
        <img src="/icons/email.svg" className='size-7'/>
      ),
    },
    {
      type: "Events/In-Person",
      icon: (
        <img src="/icons/supervisor_account.svg" className='size-7'/>
      ),
    },
  ];

  const handleButtonClick = (type) => {

    setSelectedInteraction(type);
    setIsModalOpen(true);
    // Update formData to include the selected type
    setFormData((prevData) => ({
      ...prevData,
      type: type, // Add the selected type to formData
    }));
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    // Here you can call a function to insert the data into the database
    setIsModalOpen(false);
    setFormData({ notes: "", purpose: "", date: "" }); // Reset form data
  };

  const addInteraction = async () => {
    setIsLoading(true);

    try {
      const response = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.ADD_INTERACTION}`, 'POST', formData);
      toast.success('Interaction successfully added')
      setIsModalOpen(false);

    } catch (error) {
      toast.error(error || 'Interaction not Added')
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex justify-center space-x-3">
        <p className="py-2"><b>Add:</b></p>
        {interactionTypes.map((interaction) => (
          <button
            key={interaction.type}
            onClick={() => handleButtonClick(interaction.type)}
            className={`flex items-center bg-white py-1 px-2 border-[1px] border-black justify-center w-9 h-9 rounded-full text-black hover:bg-[#E2E8F0] focus:outline-none focus:ring focus:ring-blue-300`}
          >
            {interaction.icon}
          </button>
        ))}
      </div>
      

      {/* Custom Modal */}
      {isModalOpen && createPortal(
        <div className="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg w-1/3 ">
            <div className="border-b border-gray-300 mr-5 mb-6">
            <h2 className="text-xl font-bold mb-2">Add Interaction Details</h2>
            </div>
            {selectedInteraction && <p className="mt-4">Selected Interaction: <b>{selectedInteraction}</b></p>}
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1 mt-3">Purpose:</label>
                <select
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleFormChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                >
                  <option value="" disabled>Select a purpose</option>
                  {purposeOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Date:</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleFormChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                  max={today}  // ⬅️ prevents selecting future dates
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Notes:</label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleFormChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-3 bg-white border-[1px] border-black rounded-3xl hover:bg-gray-100"
                >
                  <b>Cancel</b>
                </button>
                <button
                onClick={addInteraction}
                className={`rounded-3xl  px-8 py-3 text-black ${isLoading ? "bg-gray-500" : "bg-yellow-300 hover:bg-yellow-400"}`}
                disabled={isLoading}
              >
                {isLoading ? "Adding..." : <b>Submit</b>}
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default InteractionButtons;